import Flickity from 'flickity';

const carousels = [];

export default function () {
  document.querySelectorAll('[data-article-thumb-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {
      contain: true,
      groupCells: true,
      draggable: true,
      wrapAround: true,
    });

    carousels.push(carousel);
  });
}
